import { fetchSystemCSV } from '@api/system';
import { useSelector } from 'react-redux';
import { useAlert } from '@hooks/useAlert';
import { OrangeButton } from './OrangeButton';
import type { RootState } from '@features/redux/store';
import { fetchOrgData, OrgUrls } from '@api/org';
import { useState } from 'react';
import { Selection } from '@components/OrgNav/orgNavTypes';
import { json2csv } from 'json-2-csv';

interface ExportOrgsProps {
    params: Record<string, string>;
    type: Selection;
}

const URL_MAP: Record<Selection.Company | Selection.Reseller | Selection.Location, OrgUrls> = {
    [Selection.Company]: OrgUrls.SearchCompanies,
    [Selection.Reseller]: OrgUrls.SearchResellers,
    [Selection.Location]: OrgUrls.SearchLocations,
};

/**
 *
 * @param params - The location, reseller, and company filters
 * @param type - The type of org to export (location, reseller, company)
 */
export const ExportOrgs = ({ params, type }: ExportOrgsProps) => {
    const { IdToken } = useSelector((state: RootState) => state.auth);

    const [csvDownloading, setCsvDownloading] = useState(false);

    const { setAlert } = useAlert();

    const downloadCSV = async () => {
        setCsvDownloading(true);
        const data = await fetchOrgData<any>(
            IdToken!,
            URL_MAP[type as Selection.Location | Selection.Reseller | Selection.Company],
            params
        ).catch((err) => setAlert(err.message, 'error'));

        setCsvDownloading(false);

        if (!data) {
            setAlert('Failed to export data', 'error');
            return;
        }

        const csv = await json2csv(data);

        const csvData = `data:text/csv;base64,${btoa(unescape(encodeURIComponent(csv)))}`;

        const link = document.createElement('a');
        link.setAttribute('href', csvData);
        link.setAttribute('download', `${type}-table.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <OrangeButton loading={csvDownloading} style={{ margin: '0px' }} onClick={() => downloadCSV()}>
            Export
        </OrangeButton>
    );
};
